import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'
import { ITemplateFormValues } from 'features/Vehicles/types'

const typeMessages = defineMessages({
  required: {
    id: 'vehicles.form.type.required',
    defaultMessage: 'The type is required'
  }
})

const capacityMessages = defineMessages({
  required: {
    id: 'vehicles.form.capacity.required',
    defaultMessage: 'The capacity is required'
  }
})

const templateMessages = defineMessages({
  required: {
    id: 'vehicles.form.template.required',
    defaultMessage: 'The template is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<ITemplateFormValues> => {
  const validations = {
    template: yup.object().shape({
      id: yup.string().required(intl.formatMessage(templateMessages.required)),
      type: yup.mixed().required(intl.formatMessage(typeMessages.required)),
      capacity: yup.number().required(intl.formatMessage(capacityMessages.required))
    })
  }

  return yup.object().shape(validations)
}
